import { Card, CardsInfoTitleSub, CardTitle } from "../../components/Card";
import {  NpsBarFilterTrimester, NpsBarFilterPeriod} from "../../components/BarChart";
import { HeaderContent } from "../../components/Header";
import { EmptyGraph } from "../../components/Empty";
import DefaultPlot from "../../components/Plotly";
import { PieRecharts2 } from "../../components/PieChart";
import "./styles.scss";
import { LoadingWithLabel } from "../../components/Loading";
import moment from "moment";

export const ProjectAnalysisScreen = ({
  barChart,
  loading,
  pieChart,
  events,
  totalAssistance,
  referenceAssistance,
  totalProspeccao,
  referenceProspeccao,
  totalContactados
}) => {
  

  const CardWithBarChart = () => (
    <Card className="chart-container chart-container-project-analysis no-border">
      <>
        <HeaderContent>
          <CardTitle
            style={{ padding: "0" }}
            title="NPS dos produtores"
          />
        </HeaderContent>
        {barChart &&
        barChart?.dataTri &&
        barChart?.dataTri.length &&
        barChart?.reference.length === 0 ? (
          <NpsBarFilterTrimester data={barChart?.dataTri} />
        ) : barChart && barChart?.reference && barChart?.reference.length ? (
          <NpsBarFilterPeriod data={barChart?.reference} />
        ) : (
          <EmptyGraph />
        )}
      </>
    </Card>
  )

  const CardWithPieChart = ({ data, reference }) => (
    
    <Card className="chart-container chart-container-project-analysis no-border">
      <>
        <HeaderContent>
          <CardTitle style={{ padding: "0" }} title="Distribuição dos produtores nas fases do projeto" />
        </HeaderContent>
        <div className="card-chart-content pie-chart">
          {data && data?.length && data?.filter(item => item?.value !== 0).length || reference && reference?.length && reference?.filter(item => item?.value !== 0).length ? (
            <>
              <PieRecharts2 data1={data} data2={reference} />
            </>
          ) : (
            <EmptyGraph />
          )}
        </div>
      </>
    </Card>
  )

  const CardWithEvents = ({ events = [], eventsReference = [], subTitle = '', subTitleReference = '' }) => (
   
    <Card className="chart-container chart-container-project-analysis no-border">
      <div className="pie-chart-events">
        <div className="">
        <HeaderContent>
          <CardTitle style={{ padding: "0" }} title={'Ações efetuadas pelos usuários no aplicativo '.concat(subTitle ? `(${subTitle})` : '')} />
        </HeaderContent>
        {events && events.length > 0 ? (
          <DefaultPlot data={events} />
        ) : (
          <EmptyGraph />
        )}
        </div>
        <div className="">
        {eventsReference && eventsReference.length > 0 && JSON.stringify(events) != JSON.stringify(eventsReference) ? (
          <>
          
            <HeaderContent>
              <CardTitle style={{ padding: "0" }} title={'Ações efetuadas pelos usuários no aplicativo - Referência - '.concat(subTitleReference ? `(${subTitleReference})` : '')} />
            </HeaderContent>
            <DefaultPlot data={eventsReference} />
          </>
        ) : (
          <></>
        )}
        </div>
      </div>
    </Card>
  )

  return (
    <>
      <div className="project-analysis-container">
        <CardsInfoTitleSub
          loading={loading}
          title={totalContactados}
          subtitle="Nº de produtores cadastrados no projeto"
        />
        
        <CardsInfoTitleSub
          title={totalProspeccao || referenceProspeccao}
          subPercent={referenceProspeccao || totalProspeccao}
          percent={referenceProspeccao !== 0 && parseFloat((referenceProspeccao / totalProspeccao) * 100 - 100).toFixed(2)}
          hasPercent={true}
          subtitle="Nº de produtores em prospecção"
        />
        <CardsInfoTitleSub
          title={totalAssistance || referenceAssistance}
          subPercent={referenceAssistance || totalAssistance}
          percent={referenceAssistance !== 0 && parseFloat((referenceAssistance / totalAssistance) * 100 - 100).toFixed(2)}
          hasPercent={true}
          subtitle="Nº de produtores em atendimento"
        />
      </div>
      <div className="card-section-chart-loading">
      {loading ? <div className="card-loading">
        <LoadingWithLabel labelLoading="Atualizando dados..."/>
      </div> : <><CardWithPieChart data={pieChart?.data || []} reference={pieChart?.reference || []}/>
      <div className="card-section-chart">
        <CardWithBarChart />
        <CardWithEvents events={events?.data} eventsReference={events?.reference} subTitle={events?.date ? events?.date[0] : ''} subTitleReference={events?.date ? events?.date[1] : ''} />
      </div></>}
      </div>
    </>
  )
}
